import { yupResolver } from '@hookform/resolvers/yup'
import CancelIcon from '@mui/icons-material/Cancel'
import SaveAsIcon from '@mui/icons-material/SaveAs'
import { LoadingButton } from '@mui/lab'
import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { useAppDispatch } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import React, { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import axiosClient from 'utils/axiosClient'
import * as yup from 'yup'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: JSX.Element
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

interface IProps {
  id: string
  handleClose: () => void
}

interface FormInput {
  password: string
  rePassword: string
}
const schema = yup.object({
  password: yup.string().required().min(8).max(50),
  rePassword: yup
    .string()
    .required()
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
})

export default function DialogChangePassword({ id, handleClose }: IProps) {
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>({
    resolver: yupResolver(schema),
    defaultValues: {},
  })
  const onSubmit: SubmitHandler<FormInput> = async ({ password }) => {
    try {
      setLoading(true)
      await axiosClient.put('/api/users/' + id, {
        password,
      })
      dispatch(
        UIAction.setSnackbarMessage({
          text: 'パスワード変更完了しました。',
          type: 'success',
        })
      )
      setLoading(false)
      handleClose()
    } catch (error) {
      setLoading(false)
      dispatch(
        UIAction.setSnackbarMessage({
          text: 'エラーが発生しました。',
          type: 'error',
        })
      )
    }
  }
  return (
    <Dialog
      open={!!id}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'sm'}
      onClose={(_e, reason) => {
        if (reason !== 'backdropClick') {
          handleClose()
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: 'bold', py: 1 }}>
        パスワード変更
      </DialogTitle>
      <Box component="form" noValidate autoComplete="off">
        <DialogContent>
          <TextField
            required
            margin="dense"
            label="パスワード"
            fullWidth
            type="password"
            autoComplete="on"
            variant="standard"
            {...register('password')}
            error={'password' in errors}
            helperText={errors.password?.message}
          />
          <TextField
            required
            margin="dense"
            label="パスワード（確認）"
            fullWidth
            type="password"
            autoComplete="on"
            variant="standard"
            {...register('rePassword')}
            error={'rePassword' in errors}
            helperText={errors.rePassword?.message}
          />
        </DialogContent>
        <DialogActions>
          <Stack
            width="100%"
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            mb={2}
          >
            <Button
              sx={{
                px: 4,
                minWidth: 100,
              }}
              color="error"
              variant="contained"
              onClick={() => handleClose()}
            >
              <CancelIcon fontSize="small" />
              <Typography ml={1} variant="button">
                閉じる
              </Typography>
            </Button>
            <LoadingButton
              disabled={Object.keys(errors).length > 0}
              loading={loading}
              sx={{
                px: 4,
                minWidth: 100,
              }}
              variant="contained"
              type="submit"
              loadingPosition="end"
              endIcon={<SaveAsIcon />}
              onClick={handleSubmit(onSubmit)}
            >
              変更する
            </LoadingButton>
          </Stack>
        </DialogActions>
      </Box>
    </Dialog>
  )
}
